export default __webpack_public_path__ + "static/media/share.a2e7ba32.svg";